const AI_OFFER_DISMISSED_KEY = 'ai-employee-offer-dismissed';
export const AI_OFFER_SYNC_EVENT = 'ai-offer-dismissed-changed';

export function hasAiEmployeeProduct(
	auth: { products?: string[] } | null,
): boolean {
	return !!auth?.products?.includes('ai-employee');
}

export function isAiOfferDismissed(): boolean {
	return localStorage.getItem(AI_OFFER_DISMISSED_KEY) === 'true';
}

export function dismissAiOffer(): void {
	localStorage.setItem(AI_OFFER_DISMISSED_KEY, 'true');
	window.dispatchEvent(new CustomEvent(AI_OFFER_SYNC_EVENT));
}
